export default "__VITE_ASSET__aa97ac6c__"